import { http, toArray } from "../../lib/http";

/* ------------------------------ MARKETING ----------------------------- */
/**
 * Pauta, cupones, destacados y notificaciones.
 *
 * Todo cuelga de `/admin/marketing/*`, servido por MarketingApiController con
 * el mismo middleware de rol 4 que el resto del panel. La contraparte pública
 * —lo que consultan la app y la web— vive en `/ads/*` y no se llama desde acá.
 */
export const marketing = {
  /** KPIs del módulo: impresiones, clics, CTR, ingreso comprometido. */
  overview: (range = 30) =>
    http
      .get("/admin/marketing/overview", { params: { range } })
      .then((r) => r.data),

  advertisers: {
    list: (params) =>
      http.get("/admin/marketing/advertisers", { params }).then((r) => r.data),
    create: (body) =>
      http.post("/admin/marketing/advertisers", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/marketing/advertisers/${id}`, body).then((r) => r.data),
    remove: (id) =>
      http.delete(`/admin/marketing/advertisers/${id}`).then((r) => r.data),
    /** Catálogo ligero para poblar el selector de campañas. */
    options: () =>
      http.get("/admin/marketing/advertisers").then((r) => toArray(r.data)),
  },

  campaigns: {
    list: (params) =>
      http.get("/admin/marketing/campaigns", { params }).then((r) => r.data),
    create: (body) =>
      http.post("/admin/marketing/campaigns", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/marketing/campaigns/${id}`, body).then((r) => r.data),
    remove: (id) =>
      http.delete(`/admin/marketing/campaigns/${id}`).then((r) => r.data),
  },

  banners: {
    list: (params) =>
      http.get("/admin/marketing/banners", { params }).then((r) => r.data),
    show: (id) =>
      http.get(`/admin/marketing/banners/${id}`).then((r) => r.data),
    create: (body) =>
      http.post("/admin/marketing/banners", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/marketing/banners/${id}`, body).then((r) => r.data),
    remove: (id) =>
      http.delete(`/admin/marketing/banners/${id}`).then((r) => r.data),
    metrics: (id, range = 30) =>
      http
        .get(`/admin/marketing/banners/${id}/metrics`, { params: { range } })
        .then((r) => r.data),
  },

  coupons: {
    list: (params) =>
      http.get("/admin/marketing/coupons", { params }).then((r) => r.data),
    create: (body) =>
      http.post("/admin/marketing/coupons", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/marketing/coupons/${id}`, body).then((r) => r.data),
    remove: (id) =>
      http.delete(`/admin/marketing/coupons/${id}`).then((r) => r.data),
    redemptions: (id) =>
      http
        .get(`/admin/marketing/coupons/${id}/redemptions`)
        .then((r) => r.data),
  },

  featured: {
    list: (params) =>
      http.get("/admin/marketing/featured", { params }).then((r) => r.data),
    create: (body) =>
      http.post("/admin/marketing/featured", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/marketing/featured/${id}`, body).then((r) => r.data),
    remove: (id) =>
      http.delete(`/admin/marketing/featured/${id}`).then((r) => r.data),
  },

  push: {
    list: () => http.get("/admin/marketing/push").then((r) => r.data),
    create: (body) =>
      http.post("/admin/marketing/push", body).then((r) => r.data),
    update: (id, body) =>
      http.put(`/admin/marketing/push/${id}`, body).then((r) => r.data),
    /**
     * Cuánta gente alcanzaría el segmento, antes de enviar nada. Un envío
     * masivo no se puede deshacer, así que ver el número es la única
     * oportunidad de notar que el filtro estaba mal puesto.
     */
    preview: (segment) =>
      http
        .post("/admin/marketing/push/preview", { segment })
        .then((r) => r.data),
    send: (id) =>
      http.post(`/admin/marketing/push/${id}/send`).then((r) => r.data),
    cancel: (id) =>
      http.post(`/admin/marketing/push/${id}/cancel`).then((r) => r.data),
  },
};
